import script from "./ExcelProductTypeDraftReviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcelProductTypeDraftReviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./ExcelProductTypeDraftReviewPanel.vue?vue&type=style&index=0&id=59bbecd6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bbecd6"]])

export default __exports__